import { useCallback, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';
import { Text } from '@/components/Text';
import { useNotification } from '@/components/ui/therapist/Notification/NotificationProvider';
import { useSidebarAnimation } from '@/components/ui/therapist/CollapsibleSidebar/SidebarAnimationContext';

import PasswordGesture from '../';
import { saveNewPatternLock } from '../../../api/services/user';
import colors from '@/config/colors';
import store from '../../../stores/store';
import { PressableNeolexon } from '@/components/PressableNeolexon';

let SET_PASSWORD = '';

export default function SetPassword(props) {
  const [state, setState] = useState({
    message: 'Legen Sie ein Sperrmuster fest.',
    status: 'normal',
  });
  const { setShowHeader } = useSidebarAnimation();
  const { showNotification } = useNotification();

  async function onEnd(password) {
    if (SET_PASSWORD === '') {
      // The first password
      if (password.split(',').length < 4) {
        setState({
          status: 'wrong',
          message: 'Verbinden Sie mindestens 4 Punkte.',
        });
      } else {
        SET_PASSWORD = password;
        setState({
          status: 'normal',
          message: 'Wiederholen Sie das Sperrmuster.',
        });
      }
    } else {
      // The second password
      if (password === SET_PASSWORD) {
        const res = await saveNewPatternLock(password);
        if (res.status === 200) {
          let hash = res.hash;
          setState({
            status: 'right',
            message: 'Sperrmuster wird gesetzt...',
          });
          store.getActions().setAppLockPattern(hash.appLockPattern);
          SET_PASSWORD = '';
          props.navigation.navigate('LockScreen');
          showNotification({
            type: 'success',
            title: 'Sperrmuster geändert.',
          });
        } else {
          props.navigation.navigate('LockScreen');
        }
      } else {
        setState({
          status: 'wrong',
          title: 'Sperrmuster Wiederholung stimmt nicht überein.',
        });
      }
    }
  }

  function onStart() {
    if (SET_PASSWORD === '') {
      setState({
        message: 'Sperrmuster festlegen',
      });
    } else {
      setState({
        message: 'Wiederholen Sie das Sperrmuster.',
      });
    }
  }

  function goBack() {
    setShowHeader(true);
    SET_PASSWORD = '';
    setState({
      message: 'Sperrmuster festlegen',
      status: 'normal',
    });
    props.navigation.goBack();
  }

  useFocusEffect(
    useCallback(() => {
      setShowHeader(false);

      return () => {
        setShowHeader(true);
      };
    }, []),
  );

  return (
    <View style={styles.container}>
      <View style={{ maxHeight: 360, flex: 1 }}>
        <PasswordGesture
          status={state.status}
          message={state.message}
          onStart={() => onStart()}
          onEnd={(password) => onEnd(password)}
          innerCircle={true}
          outerCircle={true}
          showNotification={showNotification}
        />
        <View style={styles.btnContainer}>
          <PressableNeolexon onPress={() => goBack()} style={styles.btn}>
            <Text style={styles.text}>Abbrechen</Text>
          </PressableNeolexon>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    backgroundColor: colors.black,
  },
  btnContainer: {
    flexDirection: 'row',
    width: '100%',
  },
  btn: {
    flex: 1,
    borderRadius: 4,

    marginHorizontal: 10,
  },
  text: {
    textAlign: 'center',
    fontWeight: '700',
    paddingVertical: 10,
    fontSize: 16,
    color: colors.white,
  },
});
